/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-inspection': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.377.821a.5.5 0 1 0-.96 0H3.85L3.76.83a.5.5 0 0 0 .09.992h2.224l.09-.008a.5.5 0 0 0-.09-.992h-.696zm-2.893 0a.5.5 0 0 1 .09.992l-.09.008h-.496v7h6V6.321a.5.5 0 0 1 .41-.492l.09-.008a.5.5 0 0 1 .493.41l.008.09v3a.5.5 0 0 1-.41.491l-.09.008h-7a.5.5 0 0 1-.492-.41l-.008-.09v-8a.5.5 0 0 1 .41-.492l.09-.008h.995zm5.709 2.653a.5.5 0 0 1 .7.708l-.064.064-3.846 3.173a.5.5 0 0 1-.63.006l-.064-.061-1.178-1.339a.5.5 0 0 1 .685-.723l.066.062.857.975 3.474-2.865zm.81-2.243a.5.5 0 0 0-.492-.41H7.506l-.09.008a.5.5 0 0 0-.41.492l.008.09a.5.5 0 0 0 .492.41h.504l.001.515.008.09a.5.5 0 0 0 .992-.09V1.32l-.008-.09z" _fill="#376F99"/>'
  }
})
